import React from "react";
import { Link } from "react-router";
import { RoutesInvoker } from "../../routesInvoker";

import "./devDirectory.scss";

export class DevDirectory extends React.Component {
  public render() {
    return (
      <div className="dev-directory">
        <h1>Dev Directory</h1>
        <div className="guide-links">
          <Link to={RoutesInvoker.bulma()}>Bulma Guide</Link>
        </div>
      </div>
    );
  }
}
